var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background}),attrs:{"id":"main"}},[_c('v-main',[_c('MainComponent',{staticClass:"main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }